export interface Team {
  id: string
  name: string
}

export function teamAbbreviation(name: string): string {
  return (name.match(/[\p{L}\p{N}]/gu) ?? []).slice(0, 3).join('')
}
